<template>
	<div class="content-wrapper" v-if="isloaded">
		<div class="sf-flex-column">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 card_bg">
					<search-view ref="searchView" @Refresh="refresh" :scrId="scrId"></search-view>
				</sf-card>
			</div>
			<div class="position-relative sf-col sf-col-20">
				<buttons :scrId="scrId" class="mb-2"></buttons>
				<form-view :scrId="scrId" @Refresh="refresh"></form-view>
				<sf-card class="p-0 border-0 bg-transparent">
					<table-view ref="tableView" @Refresh="refresh" :scrId="scrId"></table-view>
				</sf-card>
			</div>
		</div>
	</div>
</template>

<script>
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../store/helpers';
import SearchView from './Search/Search';
import TableView from './Table/Table';
import FormView from './Table/Form';
import Buttons from './Table/Buttons';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return { isloaded: false };
	},
	async created() {
		try {
			this.isloaded = false;
			this.$sf_toggleLoading(true);
			await this.getCommCodesOnce_(); // 한번에 공통 코드 부르기
			this.setState_({ key: 'isPqyUser', value: await this.inclManyUsrGrp_(['PQYAP', 'PQYRV', 'PQYRG', 'OS']) });
			await this.getAllSgrpList_();
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error?.message || error });
		} finally {
			this.isloaded = true;
			this.$sf_toggleLoading(false);
		}
	},
	components: { SearchView, TableView, Buttons, FormView },
	methods: {
		...rootMethods,
		...qmsMethods,
		...serviceMethods,
		refresh() {
			this.$refs.searchView.searchList();
		}
	},
	computed: {
		...rootComputed,
		...qmsComputed,
		...serviceComputed
	}
};
</script>
<style lang="scss">
.fwd-cku-test {
	.sf-actions__right {
		position: absolute;
		top: 10px;
		right: 0px;
	}
}
</style>
